<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <el-container>
     
      <el-aside width="240px" v-show="isAsideVisible" >

        <img class="aside-logo" src="../assets/logo.svg" alt="" @click="goHome" />
        <div>
          <el-button type="text" class="aside_box1" @click="welcomeStatus = true">站友交流</el-button><br />

          <el-link class="aside_boxx" href="https://wevill.top" target="_blank" :underline="false">站村</el-link>
          <div class="aside_box2">
            <div class="box2_name">{{ username + "的站村" }}</div>

            <!-- 侧边栏箭头：首页态 → 进用户中心（右箭头）；用户中心态 → 返回首页（左箭头）。
                 用 slot 写 <i> 而不是 icon prop，是为了让图标带上本组件的 scopeId，样式/动效才生效。
                 新注册用户没有分类列表时侧边栏没有可点项，返回全靠这个箭头 -->
            <el-link :underline="false" @click="handleBox2ButtonClick" class="box2_button"
              :class="{ 'is-back': isUserCenter }" :title="isUserCenter ? '返回首页' : '进入用户中心'">
              <i class="el-icon-right arrow-icon"></i>
            </el-link>
          </div>

          <el-menu @select="handleClick">
            <el-menu-item v-for="menulist in menuLists" :key="menulist.id" :index="menulist.id.toString()"
              class="el-menu-item_box">
              <!-- 不在模板上写原生 autofocus：浏览器只在「页面解析阶段」处理它，
                   页面加载后由 v-if 动态插入的输入框一律不响应（实测连第 1 次点开都不聚焦）。
                   聚焦改由 showInputTwo 显式调用。
                   两个事件都显式传入 menulist：editMenuListFn 靠它识别「程序性失焦」
                   （旧输入框被卸载时也会触发 blur），否则会把刚打开的另一个编辑框关掉 -->
              <el-input v-if="inputVisibleTwo && menulist.id === editMenuList.id" v-model="menulist.name"
                @keyup.enter.native="editMenuListFn(menulist)" @blur="editMenuListFn(menulist)"
                :placeholder="errorMessage" ref="editInputRef"></el-input>

              <div v-else class="menu-item-content">
                <!-- 标题 -->
                <div class="menu-item-title">
                  {{ menulist.name }}
                </div>

                <div class="menu-item-icon">
                  <!-- 编辑图标 -->

                  <i class="el-icon-edit edit-icon" @click="showInputTwo(menulist)"></i>

                  <el-popconfirm placement="right" title="确定删除全部内容吗？" @confirm="removeMenulist(menulist.id)">
                    <i class="el-icon-circle-close close-icon" slot="reference"></i>
                  </el-popconfirm>
                </div>
              </div>
            </el-menu-item>
          </el-menu>

          <!-- 输入框与「创建新的村子」按钮同属一个容器：
               在容器外部按下鼠标即视为「点空白处」，触发保存并关闭（见 handleDocumentMouseDown） -->
          <div ref="addCunWrap" class="add-cun-wrap">
            <div v-if="inputVisible" :key="1">
              <el-form :model="addMenuList" :rules="rules" ref="addRef">
                <el-form-item prop="name">
                  <el-input v-model="addMenuList.name" ref="addInput" @keyup.enter.native="addMenulistFn"
                    placeholder="请输入1-8个汉字(英文1-24)"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div v-else :key="2">
              <el-button class="addCun" type="text" @click="showInput">创建新的村子</el-button>
            </div>
          </div>
        </div>
      </el-aside>
      <el-main ref="mainRef">
        <div class="main-content">
          <el-backtop target=".el-main"></el-backtop>

          <!-- 主内容区由子路由决定：/home/index 为首页，/home/usercenter 为用户中心。
               首页用 keep-alive 缓存（按下方的 name 匹配）：从用户中心返回时
               组件不重建、分类列表不重新请求，配合 watch.$route 恢复滚动位置 -->
          <keep-alive include="HomeIndex">
            <router-view />
          </keep-alive>
        </div>

        <el-dialog :visible.sync="welcomeStatus" width="83.333333%" top="0px" :modal="false">
          <div class="welcome_box">
            <Welcome />
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>

<script>

import Welcome from "@/components/Welcome.vue";

import {
  getCategoryListAPI,
  addCategoryAPI,
  updateCategoryAPI,
  delCategoryAPI,
} from "@/api";

export default {
  components: {
    Welcome,
  },
  data() {
    return {

      isAsideVisible: true, // 控制el-aside显示状态
      showHoverButton: false, // 控制按钮的显示隐藏

      visible: false,

      addMenuList: {
        // name: ''
      }, // 添加分类
      menuLists: [], // 分类数据
      addMenuId: null,

      editMenuListId: null,
      editMenuList: { name: "" },
      errorMessage: "请输入内容", // 用于存储验证错误消息

      inputVisible: false, // 输入框是否显示
      inputVisibleTwo: false, // 编辑输入框是否显示

      buttonStatus: false, // 图标是否显示

      welcomeStatus: false, // 欢迎页是否显示

      // 离开首页时记下的主内容区滚动位置，返回首页时恢复（见 watch.$route）
      savedIndexScrollTop: 0,

      // id: null
      rules: {
        name: [
          { validator: this.validLength, trigger: "blur" },
          // { min: 1, max: 6, message: '长度在 1 到 6 个字符', trigger: 'blur' }
        ],
      },
    };
  },
  
  
  
  
  computed: {
    username() {
      return this.$store.state.username;
    },
    userId() {
      return this.$store.state.userId;
    },
    // 当前是否在用户中心：决定侧边栏箭头是「进入」的右箭头还是「返回」的左箭头
    isUserCenter() {
      return this.$route.path === "/home/usercenter";
    },
  },
  // 路由切换时管理主内容区（.el-main）的滚动。
  // 背景：.el-main 属于布局壳，路由切换时它本身不重建，scrollTop 会被两个页面共享 ——
  //       首页滚到中间再进用户中心，用户中心会跟着「滚下来」，看不到顶部内容。
  watch: {
    $route(to, from) {
      const main = this.$refs.mainRef && this.$refs.mainRef.$el;

      // 离开首页：记住位置（返回时恢复，例如停在原来的「哥哥」分类处）
      if (from.path === "/home/index" && main) {
        this.savedIndexScrollTop = main.scrollTop;
      }

      // 等路由内容渲染完再摆正滚动位置
      this.$nextTick(() => {
        const el = this.$refs.mainRef && this.$refs.mainRef.$el;
        if (!el) return;
        if (to.path === "/home/usercenter") {
          // 用户中心一律从顶部看起
          el.scrollTop = 0;
        } else if (to.path === "/home/index") {
          // 从用户中心返回 → 回到原来的位置；从其他入口进入 → 回顶部
          el.scrollTop =
            from.path === "/home/usercenter" ? this.savedIndexScrollTop : 0;
        }
      });
    },
  },

  created() {
    // 获取文章分类
    this.initListFn();
  },

  mounted() {
    // 全局监听「按下」：用于「点输入框以外的空白处 → 保存并关闭」
    // ★ 必须用 mousedown 而不是 click。真实点击时 target 是按钮内的 <span>，click 冒泡到
    //   document 的那一轮里，Vue 已经把 v-else 的按钮节点卸载，该 <span> 变成游离节点，
    //   wrap.contains(e.target) 会误判为 false —— 结果刚点开的输入框立刻被自己关掉。
    //   mousedown 发生在任何状态变更之前，此刻 target 必然仍在文档中，判断稳定。
    document.addEventListener("mousedown", this.handleDocumentMouseDown);
  },

  beforeDestroy() {
    document.removeEventListener("mousedown", this.handleDocumentMouseDown);
  },

  methods: {

    // 侧边栏箭头：首页态 → 进入用户中心；用户中心态 → 返回首页
    // （新用户没有分类列表时侧边栏没有可点项，返回全靠这个箭头）
    handleBox2ButtonClick() {
      if (this.isUserCenter) {
        this.goHome();
      } else {
        this.goUserCenter();
      }
    },

    // 跳转用户中心（原为弹窗形式，现改为独立路由页面）
    goUserCenter() {
      if (this.$route.path !== "/home/usercenter") {
        this.$router.push("/home/usercenter");
      }
    },

    // 返回首页（点击左侧 logo）
    goHome() {
      if (this.$route.path !== "/home/index") {
        this.$router.push("/home/index");
      }
    },

    // 点击侧边栏分类：切回首页并滚动到对应分类区
    // index 为 el-menu-item 的 :index，即分类 id 的字符串形式
    handleClick(index) {
      const target = String(index);
      if (this.$route.path === "/home/index") {
        // 已在首页：直接让首页内容区滚动
        this.$bus.$emit("scroll-to-category", target);
      } else {
        // 在用户中心等其他页面：先回首页，再由首页内容区按 query 滚动
        this.$router.push({ path: "/home/index", query: { scrollTo: target } });
      }
    },

    
    // 校验字符长度的方法
    validLength(rule, value, callback) {
      function getStrLength(str) {
        return str.replace(/[^\x00-\xff]/g, "xxx").length;
      }
      if (!value) {
        callback(new Error("输入不能为空"));
      } else if (getStrLength(value) < 1) {
        callback(new Error("不能少于 1 个字符"));
      } else if (getStrLength(value) > 24) {
        callback(new Error("不能超过 24 个字符"));
      } else {
        callback();
      }
    },
    // 获取文章分类
    async initListFn() {
      try {
        const res = await getCategoryListAPI(this.userId);
        this.menuLists = res.data.data;
      } catch (error) {
        console.error('获取分类列表失败:', error);
        this.$message.error('获取分类列表失败，请重试');
      }
    },

    // 显示添加输入框，并让其自动获取焦点
    // ★ 不能用模板上的 autofocus：浏览器只在「页面解析阶段」处理它，页面加载后由
    //   v-if 动态插入的输入框一律不响应（实测连第 1 次点开都不聚焦）。
    //   改为 $nextTick 里显式 focus()，每次显隐都生效。
    showInput() {
      if (this.inputVisible) return;
      this.inputVisible = true;
      this.$nextTick(() => {
        const input = this.$refs.addInput;
        if (input) input.focus();
      });
    },

    // 在「创建新的村子」容器以外的空白处按下鼠标：保存当前内容并关闭；没有输入内容也关闭
    handleDocumentMouseDown(e) {
      if (!this.inputVisible) return; // 输入框未打开，无需处理
      if (e.button !== 0) return; // 只响应鼠标左键
      const wrap = this.$refs.addCunWrap;
      // 按在容器内（输入框本身、或「创建新的村子」按钮）时不关闭
      if (wrap && wrap.contains(e.target)) return;
      this.addMenulistFn();
    },

    // 添加分类 —— 回车 或 点击空白处 均触发：保存后关闭输入框
    addMenulistFn() {
      if (!this.inputVisible) return; // 输入框未打开时被重复触发，直接忽略

      // 先把名称取出来，避免下方重置 addMenuList 后异步回调读不到值
      const name = (this.addMenuList.name || "").trim();

      if (name) {
        // 有内容才走校验；空内容直接跳过，静默关闭（不弹校验错误）
        this.$refs.addRef.validate(async (valid) => {
          if (!valid) return; // 超长等不合法内容：不保存
          const { data: res } = await addCategoryAPI({
            userId: this.userId,
            name,
          });
          if (res.status !== 0) return this.$message.error(res.message);
          // 重新请求列表数据
          this.initListFn();
          // 通知首页内容区新增一个分类区
          this.$bus.$emit("website-category-changed");
        });
      }

      // 无论有无内容、保存是否成功，都关闭输入框并清空
      this.addMenuList = {};
      this.inputVisible = false;
    },

    // 修改分类按钮迪点击事件

    showInputTwo(menulist) {
      this.editMenuList = menulist;
      this.inputVisibleTwo = true;
        // 每次打开都显式聚焦（与「创建新的村子」同一处坑：原生 autofocus 对页面加载后
        // 动态插入的元素一律不处理）。注意本输入框位于 v-for 内，ref 会是数组
        // （v-if 只让一个渲染，数组里只有那一个），故需兼容数组与单值两种情况。
      this.$nextTick(() => {
        const refs = this.$refs.editInputRef;
        const el = Array.isArray(refs) ? refs[0] : refs;
        if (el && typeof el.focus === "function") el.focus();
      });
    },
    // // 编辑分类

    // 编辑分类：回车或失焦时保存。
    // menulist 是触发这次保存的那个分类（由模板显式传入）。区分「用户主动失焦」与
    // 「程序性失焦」很关键：切换编辑目标时，旧输入框被 v-if 卸载同样会触发 blur，
    // 若不区分，上一个分类的保存流程会跟着去提交/关闭用户刚打开的那个编辑框。
    async editMenuListFn(menulist) {
      const targetId =
        (menulist && menulist.id) ||
        (this.editMenuList && this.editMenuList.id) ||
        null;
      if (targetId == null) return;

      // 已经不是当前编辑目标（迟来的 blur）→ 直接忽略
      if (!this.editMenuList || this.editMenuList.id !== targetId) return;

      // 从列表里取最新的那一项来提交：列表刷新后 editMenuList 可能仍指向旧对象，
      // 直接提交会写回旧名字
      const current =
        this.menuLists.find((m) => m.id === targetId) || this.editMenuList;

      // 基本验证逻辑
      if (typeof current.name !== "string" || !current.name.trim()) {
        this.errorMessage = "分类名称不能为空";
        return;
      }

      // 保存是异步的，期间用户可能已切到别的分类在编辑；
      // 收尾（finally）前必须重新确认自己是否仍是当前编辑目标
      const stillEditing = () =>
        !!this.editMenuList && this.editMenuList.id === targetId;

      try {
        // 清除之前的错误消息
        this.errorMessage = "";

        // 调用 API 更新分类
        const { data: res } = await updateCategoryAPI(current);

        // 接口报错与「用户是否已切换编辑目标」无关，一律提示
        if (res.status !== 0) {
          this.$message.error(res.message);
          return;
        }

        // 成功后显示消息
        // this.$message.success("分类更新成功");

        // 保存已成功：立刻通知首页内容区同步分类标题。
        // ★ 这一步不能放到下面的守卫之后 —— 否则「改完名直接切到另一个分类」时，
        //   侧边栏刷新了、首页内容区的标题却停在旧名字上
        this.$bus.$emit("website-category-changed");

        // 重新请求列表数据。列表以 id 作 :key，正在编辑的那个输入框不会被重建，
        // 所以即便用户已切到别的分类，这一步也不会打断他
        await this.initListFn();
      } catch (error) {
        // 捕获和处理错误
        console.error("编辑分类时发生错误:", error);
        this.$message.error("编辑分类时发生错误，请重试");
      } finally {
        // 只有仍是当前编辑目标时才收尾关闭；否则会把用户刚打开的
        // 另一个分类的编辑框一并关掉（表现为「点另一个分类的铅笔没反应」）
        if (stillEditing()) {
          this.inputVisibleTwo = false;
          this.editMenuList = { name: "" };
        }
      }
    },

    // 删除-分类
    async removeMenulist(id) {
      // 先记录删除前的列表，接口失败时回滚，避免界面与数据库不一致
      const previous = this.menuLists;
      this.menuLists = this.menuLists.filter((menulist) => menulist.id !== id);

      try {
        const { data: res } = await delCategoryAPI(id);
        if (res.status !== 0) {
          this.menuLists = previous;
          this.$message.error(res.message || '删除失败');
        } else {
          // 通知首页内容区移除对应的分类区
          this.$bus.$emit("website-category-changed");
        }
      } catch (error) {
        this.menuLists = previous;
        console.error('删除分类失败:', error);
        this.$message.error('删除分类失败，请重试');
      }
    },
  },
};
</script>

<style scoped>




.el-aside {
  background-color: #ffffff;
  z-index: 1;
  height: 100vh;
  border-right: 1px solid #e7e7e7;
  
}

.el-main {
  background-color: #ffffff;
  /* 左右内边距固定 24px。不在这里写弹性内边距：内容区宽度由 .main-content 的
     968px 上限决定，若再用 vw 弹性内边距，"968"这个目标会随屏幕漂移
     （1200 屏只剩 816），banner 高度与卡片列数都会跟着抖 */
  padding: 24px 24px 400px;
  height: 100vh;
  overflow-y: auto;
}

/* ★ 全站内容区唯一宽度基准，且**随列数变化**，保证「卡片 88px + 间距 88px」在 6/7/8 列时恒定。
   宽度 = 列数 × 卡片 88 + (列数 − 1) × 间距 88：
     6 列（窗口 < 1600）→ 968   ← 设计稿基准（banner 968×200）
     7 列（窗口 ≥ 1600）→ 1144
     8 列（窗口 ≥ 1800）→ 1320
   间距不是给 grid 写死 gap，而是靠这个宽度 + 卡片行的 space-between 摊余量：
   容器宽正好等于上式时，余量 ÷ (列数−1) 恰好 = 88。
   banner / .list-box / .mainbox_one 一律 width:100% 跟随，不要再各自写宽度。
   ▲ 分档（1600 / 1800）必须与 Designone/Designtwo 的 getCardCols() 保持一致，改一处要同步另一处。 */
.main-content {
  --cols: 6;
  --card-size: 88px;
  --card-gap: 88px;
  width: 100%;
  max-width: calc(var(--cols) * (var(--card-size) + var(--card-gap)) - var(--card-gap));
  margin: 0 auto;
}

@media (min-width: 1600px) {
  .main-content { --cols: 7; }   /* 7×88 + 6×88 = 1144 */
}

@media (min-width: 1800px) {
  .main-content { --cols: 8; }   /* 8×88 + 7×88 = 1320 */
}

/* 侧边栏样式 */
.aside-logo {
  width: 148px;
  height: 40px;
  padding: 20px 52px 20px 24px;
  cursor: pointer; /* 点击 logo 返回首页 */

  background-color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 1;
  /* 将 logo 的 z-index 值设置为 1 */
}

/* a {
  text-decoration: none;
  color: #444;
}

a:hover {
  color: #ff4d90;
}

a.router-link-active {
  color: #ff4d90;
} */

.aside_box1 {
  margin-left: 24px;
  margin-top: 10px;
  padding: 0px;
  color: #1d1d1f;
  font-size: 14px;
  font-weight: bold;
}

.aside_boxx {
  margin-left: 24px;
  margin-top: 14px;
  padding: 0px;
  color: #1d1d1f;
  font-size: 14px;
  font-weight: bold;
}

.el-link.el-link--default {
  color: #1d1d1f;
}

.aside_box2 {
  display: flex;
  justify-content: space-between;
  width: 216px;
  height: 24px;
  padding-top: 16px;
  padding-left: 24px;
}

.aside_box2 .box2_name {
  font-size: 12px;
  font-weight: 500;
  color: #a8a8a8;
  line-height: 24px;
}

/* ===== 侧边栏箭头：进入用户中心 / 返回首页 =====
   分工：外层 .box2_button 管颜色 + 位移（坐标系未被旋转）；
        内层 .arrow-icon 管 180° 翻转（才不会被 translateX 打架）。 */
.aside_box2 .box2_button {
  font-size: 18px;
  color: #999;
  margin-right: 10px;
  /* 位移用带一点回弹的缓动，hover 与「轻推提示」共用 */
  transition: color 0.25s ease, transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* ★ <i> 默认是 inline，而 inline 元素上的 transform 不生效，必须转成 inline-block */
.aside_box2 .box2_button .arrow-icon {
  display: inline-block;
  transition: transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* 用户中心态：右箭头旋转 180° 变成左箭头，并用主色常亮提示「可点此返回」 */
.aside_box2 .box2_button.is-back {
  color: #ff4d90;
}

.aside_box2 .box2_button.is-back .arrow-icon {
  transform: rotate(180deg);
}

/* 进入用户中心后，整枚箭头向左轻推两下作为引导（提示「从这里返回」） */
.aside_box2 .box2_button.is-back {
  animation: box2-arrow-nudge 1.1s ease-in-out 0.35s 2;
}

@keyframes box2-arrow-nudge {
  0%,
  100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-4px);
  }
}

/* 悬停：箭头朝「将要前往的方向」再蹭一下 —— 普通态向右、返回态向左 */
.aside_box2 .box2_button:not(.is-back):hover {
  color: #333333;
  transform: translateX(3px);
}

.aside_box2 .box2_button.is-back:hover {
  transform: translateX(-5px);
}

.el-menu-item_box {
  padding-left: 24px;
  padding-right: 5px;
  /* display: flex;
  align-items: center; */
  height: 48px;
  line-height: 48px;
  /* Optional: Add border or background if needed */
}

.menu-item-content {
  height: 48px;
  display: flex;
  align-items: center;
  /* Align items vertically centered */
  justify-content: space-between;
  /* Space out items horizontally */
  width: 100%;
  /* Full width of the menu item */
}

.menu-item-title {
  height: 48px;
  margin-left: 4px;

  width: 120px;
  /* 容器的宽度 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏超出容器的文本 */
  text-overflow: ellipsis;
  /* 将超出的文本显示为省略号 */
}

.menu-item-icon {
  height: 48px;
  display: none;
  /* display: flex;
  align-items: center; */
}

.edit-icon {
  margin-right: 10px;
  color: #909399;
  cursor: pointer;
  transition: color 0.2s, transform 0.2s;
}

/* 编辑图标悬停：加深颜色并轻微放大 */
.edit-icon:hover {
  color: #333333;
  transform: scale(1.15);
}

.close-icon {
  margin-right: 10px;
  color: #909399;
  cursor: pointer;
  transition: color 0.2s, transform 0.2s;
}

/* 删除图标悬停：加深颜色并轻微放大 */
.close-icon:hover {
  color: #333333;
  transform: scale(1.15);
}

.el-menu-item:hover .menu-item-icon {
  display: block;
}



.el-menu-item_box {
  display: flex;
  justify-content: space-between;
}




.addCun {
  margin-left: 24px;
}



.welcome_box {
  /* 内容已在 Welcome 内部居中,无需额外偏移 */
  margin-left: 0;
}

</style>
